import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import ArenaxGameCard from './ArenaxGameCard';
import { ChevronRight, Users, ArrowRight } from 'lucide-react';

// Homepage strip: "Games Starting Near You". Activation engine.
// Sits between Hero and Venue Discovery as specified.
export default function ArenaxGamesNearYou() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/arenax/games/near-me?limit=6')
      .then(r => setGames(r.data.games || []))
      .finally(() => setLoading(false));
    const t = setInterval(() => api.get('/arenax/games/near-me?limit=6').then(r => setGames(r.data.games || [])).catch(() => {}), 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative py-20 px-5 sm:px-8 border-t border-cyan-500/10" data-testid="arenax-games-near-you">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-9">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Users className="h-4 w-4 text-amber-300" />
              <span className="text-[11px] tracking-[0.4em] text-amber-300 font-bold">THE ACTIVATION ENGINE</span>
            </div>
            <h2 className="text-3xl sm:text-5xl font-black text-slate-100 leading-[1.05]">
              Games starting
              <span className="block" style={{ background: 'linear-gradient(120deg, #f59e0b 0%, #06b6d4 60%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                near you.
              </span>
            </h2>
            <p className="text-sm text-slate-400 mt-2 max-w-xl">Tap to join. Pay the entry fee. Show up. Play.</p>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/arenax/games/host" data-testid="arenax-games-near-you-host">
              <button className="px-5 py-2.5 rounded-xl text-xs font-bold text-cyan-300 border border-cyan-500/40 hover:bg-cyan-500/10 transition-colors">
                + Host a Game
              </button>
            </Link>
            <Link to="/arenax/games" className="text-xs text-cyan-300 hover:text-cyan-200 flex items-center gap-1" data-testid="arenax-games-near-you-all">
              See all <ChevronRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        {loading ? (
          <div className="text-center text-slate-500 text-sm py-12">Loading the network...</div>
        ) : games.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-amber-500/20 p-10 text-center">
            <Users className="h-10 w-10 text-amber-400/50 mx-auto mb-4" />
            <h3 className="text-lg font-bold text-slate-200 mb-2">Be the first to host a game</h3>
            <p className="text-sm text-slate-500 max-w-md mx-auto mb-5">
              The first squad creates the network effect. Pick a venue, set the rules, and the city will join.
            </p>
            <Link to="/arenax/games/host" data-testid="arenax-games-empty-host">
              <button className="px-6 py-3 rounded-xl text-sm font-bold text-slate-950 inline-flex items-center gap-2"
                style={{ background: 'var(--ax-primary-gradient)' }}>
                Host the First Game <ArrowRight className="h-4 w-4" />
              </button>
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="arenax-games-near-you-grid">
            {games.map(g => <ArenaxGameCard key={g.id} game={g} />)}
          </div>
        )}
      </div>
    </section>
  );
}
